import { render, staticRenderFns } from "./DataSurvey.vue?vue&type=template&id=52cfbdcc&scoped=true&"
import script from "./DataSurvey.vue?vue&type=script&lang=ts&"
export * from "./DataSurvey.vue?vue&type=script&lang=ts&"
import style0 from "./DataSurvey.vue?vue&type=style&index=0&id=52cfbdcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cfbdcc",
  null
  
)

export default component.exports